import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
} from "react-bootstrap";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { NewsFeed, post, svg } from "../../config/imagesLink";
import AddAPhotoSharpIcon from "@mui/icons-material/AddAPhotoSharp";
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';

import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";

import { toast } from "react-hot-toast";
import { Form, Link, useLocation } from "react-router-dom";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import Select from "react-select";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import {
  applyPostPinnedState,
  extractPostInfoFromGetPostResponse,
  isPostPinnedInStorage,
  readPinnedFlagFromPostInfo,
  resolveFeedPostPinnedState,
  setPostPinnedInStorage,
} from "../../utility/newsFeedPost";
import { ImageWithLoader } from "@skeleton";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import { recordImpressions } from "../../Services/engagementService";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import ReportGmailerrorredSharpIcon from '@mui/icons-material/ReportGmailerrorredSharp';
import PersonOffSharpIcon from '@mui/icons-material/PersonOffSharp';
import UpdateSharpIcon from '@mui/icons-material/UpdateSharp';
import HideSourceSharpIcon from '@mui/icons-material/HideSourceSharp';
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp';
import ImageSharpIcon from '@mui/icons-material/ImageSharp';
import moment from "moment";
import ReactQuill from "react-quill";
import Hls from "hls.js";
import Plyr from "plyr";
import ArticleUpdate from "../Articles/ArticleUpdate";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";
import formatPostContent from "../../utility/formatPostContent";

const { pin } = svg;

const SinglePostInteraction = ({
  postId,
  AllPostList,
  singlepostList,
  singlepostListData,
  isfollowed,
  setIsfollowed,
  PostOriginType,
  postOriginId,
  ispinned,
  setIsfollowedComp,
  isfollowedComp,
  setIsConnected,
   isConnected,
  AllPostListNews,
  setSinglePostList,
  setArticle,
  article,
  connectionFromModal = false,
  setPostList = null,
  
  //   setPage,
  //   page,
  //   setTotalPages,
  //   totalPages,
  //   item,
}) => {
  console.log("singlepostListllllllllllllllll", article);
 const { t } = useTranslation();
  const sessionId = localStorage.getItem("sessionId");
  const dropdownRef = useRef(null); 
  const [showDropdown, setShowDropdown] = useState(false);
  const [updateContent, setUpdateContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const inputFileRef = useRef(null);
  const userUid = localStorage.getItem("userUid");
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");
 const location = useLocation();
  const isNewsFeed = location.pathname === "/NewsFeed";
 
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    const id = singlepostListData?.postInfo?.postId || postId;
    if (!id) return;
    recordImpressions([{ targetType: 1, targetId: id, source: 1 }]);
  }, [singlepostListData?.postInfo?.postId, postId]);

  //************************Delete Post start  ************************//
  const [show, setShow] = useState(false);
  const handleDeleteClose = () => {
    setShow(false);
  };

  const deletePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`PostAction/DeletePost`, responseData).then((res) => {
        // setShow(!show);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
        setTimeout(() => {
                    handleDeleteClose();
          
        }, 500);
        // setPostList((prevPostList) =>
        //     prevPostList.filter((post) => post.postId !== postId)
        // );
        // if ((postList.length - 1) % 10 === 0 && page === totalPages) {
        //     setTotalPages(totalPages - 1);
        // }
        // if (page <= totalPages) {
        //     AllPostList(page);
        // }
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Delete Post End  ************************//

  //************************Repost Post start  ************************//
  const [reportPost, setReportPost] = useState(false);
  const [remark, setRemark] = useState("");
  const handlereportPost = () => {
    setReportPost(false);
  };

  const ReportPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      remark: remark,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`PostAction/ReportPost`, responseData).then((res) => {
        setReportPost(!reportPost);
        setRemark("");
        // console.log("resData", res.data.message);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Repost Post End  ************************//

  //************************Pin Post start  ************************//
  const pinSyncRef = useRef(false);
  const [ispin, setIspin] = useState(
    resolveFeedPostPinnedState(singlepostList)
  );

  const syncPinnedState = (pinned) => {
    setIspin(pinned);
    setPostPinnedInStorage(postId, pinned);
    if (typeof setSinglePostList === "function") {
      setSinglePostList((prev) => {
        if (!prev) return prev;
        if (prev?.postActionsInfo) {
          return {
            ...prev,
            isPinned: pinned,
            postActionsInfo: {
              ...prev.postActionsInfo,
              isPinned: pinned,
            },
          };
        }
        if (prev?.postInfo) {
          return {
            ...prev,
            postInfo: {
              ...prev.postInfo,
              isPinned: pinned,
              postActionsInfo: {
                ...prev.postInfo.postActionsInfo,
                isPinned: pinned,
              },
            },
          };
        }
        return prev;
      });
    }
    if (typeof setPostList === "function") {
      setPostList((prev = []) => applyPostPinnedState(prev, postId, pinned));
    }
  };

  const isAlreadyPinnedError = (error) => {
    const message = String(
      error?.response?.data?.message || error?.message || ""
    ).toLowerCase();
    return message.includes("already pinned");
  };

  const syncPinStatusFromServer = async () => {
    const isOwned =
      singlepostList?.isOwned === true ||
      singlepostList?.postInfo?.isOwned === true;
    if (!postId || !isOwned) return;
    try {
      const token =
        restrictedViewerToken ||
        localStorage.getItem("restrictedViewerToken") ||
        "";
      const langKey = language === "en" ? "" : language;
      const res = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${token}&langKey=${langKey}`
      );
      const postInfo = extractPostInfoFromGetPostResponse(
        res?.data?.responseData
      );
      const pinnedFlag = readPinnedFlagFromPostInfo(postInfo);
      if (pinnedFlag !== null) {
        syncPinnedState(pinnedFlag);
      } else if (isPostPinnedInStorage(postId)) {
        syncPinnedState(true);
      }
    } catch (e) {
      // Keep local/storage state if GetPostInfo fails.
    }
  };

  useEffect(() => {
    const isOwned =
      singlepostList?.isOwned === true ||
      singlepostList?.postInfo?.isOwned === true;
    if (!isOwned || !postId || pinSyncRef.current) {
      return;
    }
    pinSyncRef.current = true;
    syncPinStatusFromServer();
  }, [postId, singlepostList?.isOwned]);

  const PinPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      postOriginType: singlepostList?.postOriginType || PostOriginType,
      postOriginUID: singlepostList?.postOriginId || postOriginId,
      langKey: language === "en" ? "" : language,
    };
    try {
      const res = await axios.post(`PostAction/PinPost`, responseData);
      setToastMessage(res.data.message);
      setShowToast(true);
      syncPinnedState(true);
    } catch (e) {
      if (isAlreadyPinnedError(e)) {
        syncPinnedState(true);
        setToastMessage(
          e?.response?.data?.message || "Post already pinned!"
        );
        setShowToast(true);
        return;
      }
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || e.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    setIspin(resolveFeedPostPinnedState(singlepostList));
  }, [
    postId,
    singlepostList?.isPinned,
    singlepostList?.isOwned,
    singlepostList?.postInfo?.isPinned,
    singlepostList?.postInfo?.isOwned,
    singlepostList?.postActionsInfo?.isPinned,
    singlepostList?.postInfo?.postActionsInfo?.isPinned,
    singlepostList?.postActionsInfo?.pinned,
    singlepostList?.postActionsInfo?.isPin,
  ]);

  //************************Pin Post End  ************************//

  //************************Unpin Post start  ************************//
  const UnPinPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      langKey: language === "en" ? "" : language,
    };
    try {
      const res = await axios.post(`PostAction/UnpinPost`, responseData);
      setToastMessage(res.data.message);
      setShowToast(true);
      syncPinnedState(false);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || e.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Unpin Post End  ************************//

  //************************Hide Post start  ************************//
  const hidePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`PostAction/HidePost`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Hide Post End  ************************//

  //************************UnHide Post start  ************************//
  const UnhidePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`PostAction/UnhidePost`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnHide Post End  ************************//

  // const [singlepostListData, setsinglepostListData] = useState("");
  // console.log('result', companyDetails);
  const PostsDetails = async () => {
    // setShowModal(true);
    try {
      // const result = await GetProfileInfo();
      const result = await axios.get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`);
      const Response = result.data.responseData.postInfo;
      // console.log("singlepostListData", Response);
      // setsinglepostListData(Response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // PostsDetails();
  }, [])
  const determinePostCategory = (postContent, newMediaFiles, existingMediaFiles) => {
    const videoExtensions = [
      ".mp4", ".webm", ".avi", ".mov", ".mkv", ".flv", ".wmv"
    ];

    const isVideo = (name) =>
      videoExtensions.includes(name?.slice(name.lastIndexOf(".")).toLowerCase());

    const hasPostContent = postContent?.trim() !== "";

    const allMedia = [...newMediaFiles, ...existingMediaFiles];

    const hasVideos = allMedia.some((file) =>
      isVideo(file.name || file.mediaName)
    );

    const hasImages = allMedia.some((file) =>
      !isVideo(file.name || file.mediaName)
    );

    // if (hasPostContent && hasVideos && !hasImages) return "TextWithVideo";
    // if (hasPostContent && hasImages && !hasVideos) return "UserStory";
    // if (hasVideos && hasImages) return "UserStory";
    // if (hasPostContent && hasVideos) return "TextWithVideo";
    // if (hasPostContent && !hasImages && !hasVideos) return "Text";
    // if (!hasPostContent && hasImages && !hasVideos) return "Image";
    // if (!hasPostContent && hasVideos && !hasImages) return "Video";
    if (hasPostContent && hasVideos && !hasImages) return "TextWithVideo";
    if (!hasPostContent && hasVideos && !hasImages) return "Video";
    if (hasPostContent && hasImages && !hasVideos) return "TextWithImage";
    if (!hasPostContent && hasImages && !hasVideos) return "Image";
    if (hasVideos && hasImages && hasPostContent) return "TextWithVideo"; // ✅ treat as TextWithVideo not UserStory
    if (hasVideos && hasImages && !hasPostContent) return "UserStory"; // purely media mix
    if (hasPostContent && !hasImages && !hasVideos) return "Text";
    return "UserStory"; // default fallback
  };



  const UpdatePostAsDraft = async () => {
    try {
      // if (postContent !== "" && imageNames !== '') {
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append(
        "PrivacyType",
        privacyType === "" ? "Public" : privacyType
      );
      formData.append("PostOriginType", "User");
      // Convert comma-separated imageNames string into an array
      const imageNameArray = imageNames
        .split(",")
        .filter((name) => name.trim() !== "");

      // Function to check if the list contains any video files
      const containsVideo = (names) => {
        const videoExtensions = [
          ".mp4",
          ".webm",
          ".avi",
          ".mov",
          ".mkv",
          ".flv",
          ".wmv",
        ];
        return names.some((name) =>
          videoExtensions.includes(
            name.slice(name.lastIndexOf(".")).toLowerCase()
          )
        );
      };

      // Determine PostCategory
      let postCategory;
      const hasPostContent = postContent !== "";
      const hasImages =
        imageNameArray.length > 0 && !containsVideo(imageNameArray);
      const hasVideos =
        imageNameArray.length > 0 && containsVideo(imageNameArray);

      if (hasPostContent && hasImages && hasVideos) {
        postCategory = "UserStory";
      } else if (hasPostContent && hasImages) {
        postCategory = "UserStory";
      } else if (hasPostContent && hasVideos) {
        postCategory = "UserStory";
      } else if (hasImages && hasVideos) {
        postCategory = "UserStory";
      } else if (hasPostContent) {
        postCategory = "Text";
      } else if (hasImages) {
        postCategory = "Image";
      } else if (hasVideos) {
        postCategory = "Video";
      } else {
        postCategory = "UserStory"; // Default case
      }

      formData.append("PostCategory", postCategory);
      formData.append("PostContent", postContent);
      formData.append("FilesToUpload", imageNames);
      formData.append("PostOriginID", userUid);
      formData.append("PostId", postId);
      formData.append("langKey", language === "en" ? "" : language);

      // console.log("formData", formData);

      const res = await axios.post("/Posts/UpdatePost", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // console.log("response: ", res);
      //   toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      setPostID(res.data.responseData.id);
      setPostContent("");
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [privacyType, setPrivacyType] = useState(null);

  const [showPost, setShowPost] = useState(false);

  useEffect(() => {
    if (showPost && inputFileRef.current) {
      inputFileRef.current.click();
    }
  }, [showPost]);

  const handleShowPost = () => {
    setShowModal(false);
    setShowPost(true);
  };



  const [images, setImages] = useState([]);

  const deleteImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const renderImages = () => {
    return images.map((image, index) => (
      <div
        key={index}
        className="image_container d-flex justify-content-center position-relative"
      >
        <img src={image.url} alt={image.name} />
        <span className="position-absolute" onClick={() => deleteImage(index)}>
          &times;
        </span>
      </div>
    ));
  };

  const privacy = [
    { value: "Public", label: t("Newsfeed.Public") , icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends") , icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom") , icon: <TuneSharpIcon /> },
    // { value: "Public", label: "Public", icon: <PublicSharpIcon /> },
    // { value: "Friends", label: "Friends", icon: <GroupSharpIcon /> },
    // { value: "OnlyMe", label: "OnlyMe", icon: <LockSharpIcon /> },
    // { value: "Custom", label: "Custom", icon: <TuneSharpIcon /> },
  ];

  const handleClosePost = () => {
    setShowPost(false);
  };

  const [postContent, setPostContent] = useState("");
  const [postID, setPostID] = useState("");
  const [display, setDisplay] = useState(false);
  const [imageNames, setImageNames] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);

  const handleImageChange = (event) => {

    UpdatePostAsDraft();
    const files = Array.from(event.target.files);
    const fileNames = files.map((file) => file.name);
    setImageNames(fileNames.join(", "));
    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setSelectedImages((prevImages) => [...prevImages, ...imageUrls]);
  };

  const handleRemoveImage = (index) => {
    UpdatePostAsDraft();
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImageNames((prevNames) => {
      const namesArray = prevNames.split(", ");
      namesArray.splice(index, 1);
      return namesArray.join(", ");
    });
  };



  const copyPost = async () => {
    const copyData = {
      deviceType: "Web",
      id: postId,
      type: 1,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("SMFeatures/SaveShareURL", copyData).then((res) => {
        navigator.clipboard.writeText(res.data.responseData.value);
        // toast.success('Link Copied')
        setToastMessage("Link Copied");
        setShowToast(true);
      });
    } catch (e) {
      // console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const FollowUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("UserFollow/FollowUser", data).then((resData) => {
        // console.log("resDataaaaa", resData);
        setIsfollowed(true)
        setToastMessage(resData.data?.message);
        setShowToast(true);
        // update newsfeed posts to reflect follow
        if (setPostList) {
          setPostList((prev = []) =>
            prev.map((p) =>
              p?.postInfo?.userUid === id
                ? {
                    ...p,
                    postInfo: {
                      ...p.postInfo,
                      isFollowedByYou: true,
                    },
                  }
                : p
            )
          );
        }
      });
    } catch (e) {
      console.log("error", e);

      if (e.response && e.response?.status === 404 || e.response?.status === 400) {
        setWarningToastMessage(e.response.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data?.message);
        setShowErrorToast(true);
      }
    }
  };

  const [showUnfollowModal, setShowUnfollowModal] = useState(false);
  const handleCloseUnfollowModal = () => setShowUnfollowModal(false);
  const handleShowunfollowModal = () => setShowUnfollowModal(true);

  const unFollowUser = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: singlepostList?.userUid,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
        // console.log("res", res);
        setIsfollowed(false)
        setToastMessage(res.data?.message);
        setShowToast(true);
        handleCloseUnfollowModal()
        // update newsfeed posts to reflect unfollow
        if (setPostList) {
          setPostList((prev = []) =>
            prev.map((p) =>
              p?.postInfo?.userUid === singlepostList?.userUid
                ? {
                    ...p,
                    postInfo: {
                      ...p.postInfo,
                      isFollowedByYou: false,
                    },
                  }
                : p
            )
          );
        }
      });
    } catch (e) {
      console.log("error", e);

      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data?.message);
        setShowErrorToast(true);
      }
    }
  };


  // useEffect(() => {
  //   if (showModal || showPost || show || reportPost || showUnfollowModal) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showModal, showPost, show, reportPost, showUnfollowModal]);

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handlePaste = (e) => {
    const isCtrlV = e.ctrlKey && e.key === "v"; // Check if Ctrl+V was pressed

    if (isCtrlV) {
      e.preventDefault(); // Prevent the default paste action
      alert("Please use Ctrl + Shift + V to paste."); // Show alert
    }
  };

  //Handle Shared Post Update
  const [postContentMap, setPostContentMap] = useState({});
  const [fullContentData, setFullContentData] = useState(null);
  const [sharedPostContent, setSharedPostContent] = useState("");

  const readMore = async (id) => {
    try {
      const res = await axios.get(
        `/Posts/GetPostMainContent/?DeviceType=Web&PostId=${id}&langKey=${language}`
      );
      if (res?.data?.responseData) {
        setFullContentData(res.data.responseData);
      }
      setPostContentMap((prevMap) => ({
        ...prevMap,
        [id]: res.data.responseData,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const replaceDynamicValues = (content, dynamicValues = []) => {
    if (!content) return content;
    const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];
    let result = content;
    safeDynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const displayName = item.displayName ?? item.display ?? "";
      const entityId = item.entity ?? item.entityID ?? "";
      let replacement = "";

      if (item.type === "UserMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "CompanyMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "Hashtag") {
        replacement = `#${displayName}`;
      }

      result = result.replaceAll(placeholder, replacement);
    });

    return result;
  };


  // const normalizeDynamicValues = (dynamicValues = []) => {
  //   return (dynamicValues || []).map((dv, idx) => {
  //     if (!dv) return null;
  //     const {
  //       type,
  //       dVno,
  //       // possible incoming names:
  //       entity,
  //       entityID,
  //       entityId,
  //       userUid,
  //       displayName,
  //       display,
  //       entityName,
  //       hashTag,
  //     } = dv;

  //     return {
  //       type: type || (hashTag ? "Hashtag" : "UserMention"),
  //       dVno: dVno ?? idx + 1,
  //       // prefer entity, fallback to possible alternate keys
  //       entity:  entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? displayName ,
  //       // prefer displayName, fallback to others
  //       displayName: displayName ?? display ?? entityName ?? hashTag ?? "",
  //     };

  //   }).filter(Boolean);
  // };

  const normalizeDynamicValues = (dynamicValues = []) => {
    return (dynamicValues || []).map((dv, idx) => {
      if (!dv) return null;
      const {
        type,
        dVno,
        // possible incoming names:
        entity,
        entityID,
        entityId,
        userUid,
        displayName,
        display,
        entityName,
        hashTag,
      } = dv;

      // Determine the type first
      const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");

      // Resolve the display name
      const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

      // Resolve the entity (ID for User/Company, Text/ID for Hashtag)
      let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

      // 🚨 FIX: If it's a Hashtag, ensure the entity is the display name (text)
      // This forces the entity back to the human-readable text, overriding any server-side ID
      if (resolvedType === "Hashtag") {
        resolvedEntity = resolvedDisplayName;
      }

      return {
        type: resolvedType,
        dVno: dVno ?? idx + 1,
        entity: resolvedEntity,
        displayName: resolvedDisplayName,
      };

    }).filter(Boolean);
  };

  const processExpandedContent = (expandedContent, fallbackDynamicValues = []) => {
    let resolvedContent = expandedContent;
    let resolvedDynamicValues = fallbackDynamicValues;

    if (expandedContent && typeof expandedContent === "object") {
      resolvedContent =
        expandedContent?.postContent ||
        expandedContent?.mainContent ||
        expandedContent?.content ||
        expandedContent?.postMainContent ||
        "";

      if (Array.isArray(expandedContent?.dynamicValues) && expandedContent.dynamicValues.length) {
        resolvedDynamicValues = expandedContent.dynamicValues;
      }
    }

    const withDynamicValues = replaceDynamicValues(
      resolvedContent || "",
      resolvedDynamicValues || []
    );

    const cleanedContent = withDynamicValues.replace(/\{\d+\}/g, "");

    return {
      content: cleanedContent,
      dynamicValues: resolvedDynamicValues,
    };
  };

  // useEffect(() => {
  //   if (singlepostListData?.postInfo?.postContent) {
  //     const normalized = normalizeDynamicValues(singlepostListData.postInfo.dynamicValues || []);
  //     const formatted = linkifyContent(
  //       addTargetBlankToAnchors(
  //         replaceDynamicValues(singlepostListData.postInfo.postContent, singlepostListData.postInfo.dynamicValues)
  //       )
  //     );

  //     setSharedPostContent(formatted);
  //     setPostContent(formatted);
  //     const initialPostInput = updatePostInputValueWithDynamicValues(formatted, normalized);
  //     setPostInputValue(initialPostInput);
  //   }
  // }, [singlepostListData]);


  useEffect(() => {
    const rawHtml = singlepostListData?.postInfo?.postContent;
    const normalizedDynamicValues = normalizeDynamicValues(
      singlepostListData?.postInfo?.dynamicValues || []
    );

    // const replaced = replaceDynamicValuesForView(rawHtml, item?.postInfo?.dynamicValues);
    // const withLinks = linkifyContent(replaced);
    // const finalContent = addTargetBlankToAnchors(withLinks);
    // setSharedPostContent(finalContent);

    const replacedForEditor = replaceDynamicValues(rawHtml, normalizedDynamicValues);
    setPostContent(replacedForEditor);
    setSharedPostContent(replacedForEditor);
    setPostDynamicValues(normalizedDynamicValues);
  }, [singlepostListData]);

  useEffect(() => {
    if (!showModal) return;

    if (singlepostListData?.postInfo?.readMore === true) {
      readMore(singlepostListData?.postInfo?.postId || postId);
    }
  }, [showModal, singlepostListData?.postInfo?.readMore, singlepostListData?.postInfo?.postId, postId]);

  useEffect(() => {
    if (!fullContentData || !showModal) return;

    const { content: processedContent, dynamicValues: processedDynamicValues } =
      processExpandedContent(fullContentData, singlepostListData?.postInfo?.dynamicValues || []);

    const normalizedRaw = normalizeDynamicValues(processedDynamicValues);
    const normalized = Array.isArray(normalizedRaw) ? normalizedRaw : [];

    const replacedForEditor = replaceDynamicValues(processedContent || "", normalized);

    setSharedPostContent(replacedForEditor);
    setPostContent(replacedForEditor);
    setPostInputValue(processedContent || "");
    setPostDynamicValues(normalized);
  }, [fullContentData, showModal, singlepostListData?.postInfo?.dynamicValues]);

  const sharedPostFormattedContent1 = formatPostContent(
    singlepostListData?.postInfo?.sharedPost?.postContent,
    singlepostListData?.postInfo?.sharedPost?.dynamicValues
  );

  const editorRef = useRef(null);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [SearchText, setSearchText] = useState("")
  const [isloading, setIsloading] = useState(false);
  const [removedImageIds, setRemovedImageIds] = useState([]); // To track removed image IDs

  const [selectedIndex, setSelectedIndex] = useState(0);
  const suggestionListRef = useRef(null);
  const itemRefs = useRef([]);

  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);

  const handleChange = (content, delta, source, editor) => {
    console.log("Handle Content===>", content)
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setSharedPostContent(content);
    setPostContent(content)
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, displayName, display }) => {
        const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
        // const fullMention = `${prefix}${display}`;
        // return value.includes(fullMention);
        return value.includes(`${prefix}${displayName || display}`);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, displayName, display }) => {
      const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const fullMention = `${prefix}${displayName || display}`;
      // const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      const regex = new RegExp(
        `${escapeRegex(fullMention)}(?=\\s|&nbsp;|<|$)`,
        "gi"
      );
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value?.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid, entityType) => {
    console.log("Inserting Mention:", { suggestion, userUid, entityType });
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" || entityType === "CompanyMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName || display} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText, 'user');
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];

    const dVno = safePostDynamicValues.length + 1;

    // const updatedPostDynamicValues = [
    //   ...safePostDynamicValues,
    //   {
    //     type: mentionType,
    //     dVno,
    //     entity: mentionType === "UserMention" ? userUid : suggestion,
    //     display: displayName,
    //   },
    // ];
    let newDynamicValue = null;
    if (mentionType === "UserMention" || entityType === "CompanyMention") {
      newDynamicValue = {
        type: entityType || mentionType,
        dVno,
        entity: userUid, // userUid or companyUid
        display: displayName,
      };
    } else if (mentionType === "Hashtag") {
      newDynamicValue = {
        type: "Hashtag",
        dVno,
        entity: suggestion || displayName, // naya ya existing hashtag text
        display: displayName,
      };
    }
    const updatedPostDynamicValues = [...safePostDynamicValues, newDynamicValue]
    setPostDynamicValues(updatedPostDynamicValues);
    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.entityName : selectedItem?.hashTag,
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      } else if (e.key === " ") {
        // Space pressed while suggestions open:
        // - For hashtag: commit manual typed hashtag (SearchText) as mention
        // - For mention: just close suggestions
        if (mentionType === "Hashtag") {
          e.preventDefault();
          if (SearchText && SearchText.trim()) {
            insertMention(SearchText.trim(), null);
          }
        }
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    } else {
      if (e.key === " ") {
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    }
  };


  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);

  const updateSharedPost = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const payload = {
        DeviceType: "Web",
        sessionId: sessionId,
        postId: postId,
        originPostId: userUid,
        PrivacyType: privacyType || "Public",
        // PostContent: editorContent,
        PostContent: postInputValue ? postInputValue : sharedPostContent,
        DynamicValues: normalizeDynamicValues(postDynamicValues),
              langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("/Posts/UpdateSharedPost", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setToastMessage(res?.data?.message);
      setShowToast(true);
      closeModal();
      AllPostList();
      setPostDynamicValues([]);
      setPostInputValue("");
      // const newPostId = res?.data?.responseData?.id;
      // const postDetailsResponse = await axios.post(
      //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}`
      // );
      // const newPost = postDetailsResponse?.data?.responseData;
      // setPostList((prev) => [newPost, ...prev]);
      setPostContent("");
      // setImages([])D;
      setPostID("");
      // setShowSecondModal(false);
      setIsloading(false);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      // console.log("newPostId", error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
        setIsloading(false);

      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };

  const handleSubmit = async () => {
    setIsloading(true);
    try {
      if (singlepostListData.cntntTypCategory === "TextWithVideo" || singlepostListData.cntntTypCategory === "Video") {

        const VideoPostCategory = determinePostCategory(
          postContent,
          images, // new media files
          userSelectedImage
        );

        const videoBody = {
          deviceType: "Web",
          sessionId: sessionId,
          postId: postId,
          privacyType: privacyType === null ? "Public" : privacyType,
          postCategory: VideoPostCategory,
          postContent: postInputValue || postContent || "",
          dynamicValues: normalizeDynamicValues(postDynamicValues),
                langKey: language === "en" ? "" : language,

        };

        const response = await axios.post("Posts/UpdateVideoPost", videoBody,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        // console.log("Video Post Updated:", response.data);
        setToastMessage(response.data.message);
        setShowToast(true);
      } else {
        const formData = new FormData();
        formData.append("PostId", postId);
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append(
          "PrivacyType",
          privacyType === null ? "Public" : privacyType
        );
        formData.append("PostOriginType", PostOriginType);
        // const newImages = images.map((image) => image.name);
        // const existingImages = userSelectedImage.map((image) => image.mediaName);
        const newImages = (images || []).map((image) => image.name);
        const existingImages = (userSelectedImage || [])
          .filter(img => !removedImageIds.includes(img.pstMid))
          .map(image => image.mediaName);
        const postCategory = determinePostCategory(
          postContent,
          newImages,
          existingImages
        );

        formData.append("PostCategory", postCategory);
        formData.append("PostContent", postInputValue || postContent || "");
        const normalizedDynamicValues = normalizeDynamicValues(postDynamicValues);
        formData.append("DynamicValues", JSON.stringify(normalizedDynamicValues));
        // formData.append("DynamicValues", JSON.stringify(postDynamicValues));

        removedImageIds.forEach((id) => {
          formData.append("OldFilesToDelete", id);
        });
        images.forEach((file) => {
          formData.append(`FilesToUpload`, file.file);
        });

        formData.append("PostOriginID", singlepostListData?.postInfo?.userUid);
        formData.append("langKey", language === "en" ? "" : language);
        const res = await axios.post("/Posts/UpdatePost", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        // setWarningToastMessage(res.data?.message || "Not Found");
        // setShowWarningToast(true);

        if (res.status === 200) {
          setToastMessage(res.data.message);
          setShowToast(true);
        }
      }
      AllPostList();

      setTimeout(() => {
        closeModal();
      }, 300);
      // setPostContent("");

      setIsloading(false);
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message || "Not found");
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message || "Something went wrong");
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };

  const imageSelect = (event) => {
    // console.log("image selected", event);
    const selectedFiles = event.target.files;
    // console.log("selectedFiles", selectedFiles);
    const newImages = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageName = selectedFiles[i].name;
      if (!checkDuplicate(imageName)) {
        const imageUrl = URL.createObjectURL(selectedFiles[i]);
        newImages.push({
          name: imageName,
          url: imageUrl,
          file: selectedFiles[i],
        });
      } else {
        alert(`${imageName} is already added to the list`);
      }
    }

    setImages((prevImages) => [...prevImages, ...newImages]);
    event.target.value = null; // Reset file input
    // console.log("image selected1", images);
  };

  const checkDuplicate = (name) => {
    return images.some((image) => image.name === name);
  };

  const [userSelectedImage, setUserSelectedImage] = useState({});
  // console.log("image index", userSelectedImage);
  const userImages = (index) => {
    const removedImage = userSelectedImage[index];
    setRemovedImageIds((prevIds) => [...prevIds, removedImage.pstMid]); // Add removed image ID to the state
    setUserSelectedImage((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  useEffect(() => {
    setUserSelectedImage(singlepostListData?.postInfo?.mediaFilesList); // Initialize the state with the media files list
    // console.log("useEffect is run");
  }, [singlepostListData?.postInfo?.mediaFilesList]);

useEffect(() => {
  if (singlepostList) {
    // setIsfollowed(singlepostList.isFollowedByYou);
  }
}, [singlepostList]);

  // console.log("userSelectedImage", userSelectedImage, images);

  const mainVideoRef = useRef(null);
  const sharedVideoRef = useRef(null);


  useEffect(() => {
    if (!openModal) return;

    const waitForRef = () => {
      const currentVideoRef = mainVideoRef.current;

      if (!currentVideoRef) {
        requestAnimationFrame(waitForRef);
        return;
      }

      const videoId = singlepostListData?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
      const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken });

      const hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(currentVideoRef);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const plyrInstance = new Plyr(currentVideoRef, {
          captions: { active: true, update: true, language: "en" },
        });
        currentVideoRef.muted = true; // always start muted
        currentVideoRef.play().catch(err => console.warn("Play failed", err));
      });
    };

    waitForRef();

  }, [openModal, singlepostListData, restrictedViewerToken]);

  useEffect(() => {

    if (openModal && singlepostListData?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaType === "Video") {
      const videoId = singlepostListData?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo;
      // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
      const region = "centralindia";
      const currentVideoRef = sharedVideoRef.current;

      // console.log("Shared videoId:", videoId);

      if (!videoId || !restrictedViewerToken || !currentVideoRef) {
        console.error("Missing shared videoId or token or ref.");
        return;
      }

      const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken, region: region });
      // console.log("Shared manifestUrl:", manifestUrl);

      let hls;
      let plyrInstance;

      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(manifestUrl);
        hls.attachMedia(currentVideoRef);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // console.log("✅ Shared Manifest parsed");
          plyrInstance = new Plyr(currentVideoRef, {
            captions: { active: true, update: true, language: "en" },
          });
          currentVideoRef?.play().catch(err => {
            console.warn("Shared video play interrupted", err);
          });
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error("HLS.js Shared Video Error:", data);
        });
      } else if (currentVideoRef.canPlayType("application/vnd.apple.mpegurl")) {
        // console.log(" Native HLS fallback for shared video");
        currentVideoRef.src = manifestUrl;
        currentVideoRef.addEventListener("loadedmetadata", () => {
          currentVideoRef?.play();
        });
      }

      return () => {
        if (plyrInstance) plyrInstance.destroy();
        if (hls) hls.destroy();
      };
    }
  }, [singlepostListData, restrictedViewerToken]);


   //************************ Send Connection Request ************************//
    const SendConnectionRequest = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        userUID: id,
        langKey: language === "en" ? "" : language,
      };
      console.log(data);
      try {
        await axios
          .post("Connection/SendConnectionRequest ", data)
          .then((resData) => {
            setToastMessage(resData.data.message);
            setShowToast(true);
            // Request was sent — mark as 'Sent' but do NOT mark as connected.
            setConnectionCheck("Sent");
            CheckConnectUser(id);
          });
        } catch (error) {
          if (error?.response && error?.response?.status === 404) {
            setWarningToastMessage(error?.response?.data?.message);
            setShowWarningToast(true);
          } else {
            console.log("wwwwwwwwww",error);
            
            setErrorToastMessage(error?.response?.data?.message);
            setShowErrorToast(true);
          }
        }
      };

   //************************ Accept Incoming Connection Request ************************//
    const AcceptIncomingRequest = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        userUID: id,
        connectID: connectionId,
        actionType: "Accept",
        langKey: language === "en" ? "" : language,
      };
      try {
        await axios
          .post("Connection/ConnectionRequestAction", data)
          .then((resData) => {
            setToastMessage(resData.data.message);
            setShowToast(true);
            setConnectionCheck("Connected");
            if (setIsConnected) setIsConnected(true);
            if (setPostList) {
              setPostList((prev = []) =>
                prev.map((p) =>
                  p?.postInfo?.userUid === id
                    ? {
                        ...p,
                        postInfo: {
                          ...p.postInfo,
                          isConnectedByYou: true,
                        },
                      }
                    : p
                )
              );
            }
            CheckConnectUser(id);
          });
      } catch (error) {
        if (error?.response && error?.response?.status === 404) {
          setWarningToastMessage(error?.response?.data?.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error?.response?.data?.message);
          setShowErrorToast(true);
        }
      }
    };
  //************************Cancel Request   ************************//
  const [showCancelM, setShowCancelM] = useState(false);
  const [Uid, setUid] = useState(null);
  const cancelRequestClose = () => {
    setShowCancelM(false);
  }; 
  const CancelRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: Uid,
            langKey: language === "en" ? "" : language,

    };
    console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          console.log(resData); 
          //   toast.success(resData.data.message);
          setToastMessage(resData?.data?.message);
          setShowToast(true);
          setIsConnected(false)
          setConnectionCheck(null);
          setConnectionId(null);
          // update newsfeed posts to reflect cancelled request
          if (setPostList) {
            setPostList((prev = []) =>
              prev.map((p) =>
                p?.postInfo?.userUid === Uid
                  ? {
                      ...p,
                      postInfo: {
                        ...p.postInfo,
                        isConnectedByYou: false,
                      },
                    }
                  : p
              )
            );
          }
          CheckConnectUser(Uid);
          cancelRequestClose();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e?.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };
 //************************Disconnect Request   ************************//
   //************************Disconnect Request   ************************//
   
 const [showModalDisC, setShowModalDisC] = useState(false);
  const handleShowModal = ( ) => {  
    setShowModalDisC(true);
  };

  const handleCloseModal = () => {
    setShowModalDisC(false); 
  };
  const DisconnectUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: Uid,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios.post("Connection/DisconnectUser", data).then((resData) => {
        console.log(resData);
        // setShowModalDisC(!showModalDisC);
        //   toast.success(resData.data.message);
        setConnectionCheck(null); // 🔥 THIS IS KEY
        setConnectionId(null);
        setToastMessage(resData.data.message);
        setShowToast(true);
        // update newsfeed posts to reflect disconnect
        if (setPostList) {
          setPostList((prev = []) =>
            prev.map((p) =>
              p?.postInfo?.userUid === Uid
                ? {
                    ...p,
                    postInfo: {
                      ...p.postInfo,
                      isConnectedByYou: false,
                    },
                  }
                : p
            )
          );
        }
        CheckConnectUser();
        handleCloseModal()
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Disconnect Request ************************//
 

     //************************ Follow Company  ************************//
    
      const FollowCompany = async (id) => {
        const data = {
          deviceType: "Web",
          sessionId: sessionId,
          uiD_ID: id,
                langKey: language === "en" ? "" : language,
    
        };
        try {
          await axios.post("Entity/Follow/Company", data).then((resData) => {
              // CompanyDetails();
              setIsfollowed(true);
              setToastMessage(resData.data.message);
              setShowToast(true);
              setIsfollowedComp(true);

              // refresh newsfeed to reflect company follow
              try {
                if (AllPostListNews) AllPostListNews();
                else if (AllPostList) AllPostList();
              } catch (e) {}
            });
        } catch (e) {
          if (e.response && e.response.status === 404) {
            setWarningToastMessage(e.response.data.message);
            setShowWarningToast(true);
          } else {
            setErrorToastMessage(e.response.data.message);
            setShowErrorToast(true);
          }
        }
      };
     const [connectionCheck, setConnectionCheck] = useState("");
    console.log("connectionCheck", connectionCheck);
  
    const [connectionId, setConnectionId] = useState("");
    // api removed from backend
    const CheckConnectUser = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        userUID: id,
        langKey: language === "en" ? "" : language,
      };
      try {
        await axios.post("Connection/CheckConnection", data).then((resData) => {
          console.log("checkFollowedUser", resData.data);
          const value = resData?.data?.responseData?.value;
          if (value) {
            setConnectionCheck(value);
            setConnectionId(resData.data.responseData.id);
          }
        });
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
    if (singlepostList?.postOriginType !== "Company" &&
      singlepostList?.isConnectedByYou  === null) {
      CheckConnectUser(singlepostList.userUid);
      console.log("checkingggg", singlepostList?.isConnectedByYou);
    }
  }, [singlepostList?.isConnectedByYou]);

    const isFollowed =
  isfollowed || singlepostList?.isFollowedByYou;

const isConnectedCheck = connectionCheck === "Connected";
const isRequestSent = connectionCheck === "Sent";
const isRequestReceived = connectionCheck === "Received"; 
  const isNoConnection =
  !connectionCheck || connectionCheck === "None";

   //************************ UnFollow Company  ************************//
  
    const UnFollowCompany = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        uiD_ID: singlepostList?.userUid,
              langKey: language === "en" ? "" : language,
  
      };
      try {
        await axios.post("Entity/Unfollow/Company", data).then((resData) => {
          // CompanyDetails();
          setToastMessage(resData.data.message);
          setShowToast(true);
          setIsfollowedComp(false);
          handleCloseUnfollowModal();
           // sync company unfollow in newsfeed
           try {
             setPostList((prev = []) =>
               prev.map((p) =>
                 p?.postInfo?.postId === postId || p?.postInfo?.userUid === singlepostList?.userUid
                   ? {
                       ...p,
                       postInfo: {
                         ...p.postInfo,
                         isFollowedByYou: false,
                       },
                     }
                   : p
               )
             );
           } catch (e) {}
        });
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    };


  const handleSinglePostInteractionEscapeClose = useCallback(() => {
    if (showModal) {
      if (showSuggestions) {
        setShowSuggestions(false);
        return;
      }
      closeModal();
    } else if (showPost) {
      handleClosePost();
    } else if (showUnfollowModal) {
      handleCloseUnfollowModal();
    } else if (showCancelM) {
      cancelRequestClose();
    } else if (showModalDisC) {
      handleCloseModal();
    }
  }, [
    showModal,
    showSuggestions,
    closeModal,
    showPost,
    handleClosePost,
    showUnfollowModal,
    handleCloseUnfollowModal,
    showCancelM,
    cancelRequestClose,
    showModalDisC,
    handleCloseModal,
  ]);

  useEscapeKeyDown(
    showModal || showPost || showUnfollowModal || showCancelM || showModalDisC,
    handleSinglePostInteractionEscapeClose
  );

  return (
    <>
      <div className="d-flex">
        {ispin ? (
          <PushPinIcon className="material-symbols-sharp me-2 post-pin-icon" />
        ) : null}

        {singlepostList?.isOwned === false ? <>
           
         
          {isNewsFeed &&
          !isConnectedCheck &&
          singlepostList?.isConnectedByYou !== true && (
            <>
              {/* FOLLOW */}
             {!isFollowed && (
                <div className="ms-auto">
                  <button
                    className="mainBtn1 me-2 ms-2"
                    style={{ height: "30px" }}
                    onClick={() => {
                      singlepostList?.postOriginType === "Company"
                        ? FollowCompany(singlepostList?.userUid)
                        : FollowUser(singlepostList?.userUid);
                    }}
                  >
                    {t("Newsfeed.Follow")}
                  </button>
                </div>
                )}

              {/* CONNECT — only when no pending request either way */}
             { isFollowed &&
                isNoConnection && 
                !singlepostList?.isConnectedByYou &&
                singlepostList?.postOriginType !== "Company" &&   
                (
                <div className="ms-auto">
                  <button 
                    className="mainBtn1 me-2 ms-2"
                    style={{ height: "30px" }}
                    onClick={() => SendConnectionRequest(singlepostList.userUid)}
                  >
                    {t("Newsfeed.Connect")}
                  </button>
                </div>
              ) }

            </>
          )}
           



        </> : ''}
         

        <div
          className="postMenu pointer"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />
          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal"
              style={{ top: "auto" }}
            >
              {singlepostList?.isOwned === false && (
                <>
                  {/* {singlepostList?.isfollowed === true || singlepostList?.isFollowedByYou === true ? */}
                 
                   {isFollowed && (
                    <Dropdown.Item as="button" className="dropdownList">
                      <div
                    
                        onClick={() => {
                          handleShowunfollowModal()
                          toggleDropdown();
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <PersonOffSharpIcon className="material-symbols-sharp me-2" />
                          <span className="dropdownTxt f-14 redText"> {t("Newsfeed.Unfollow")}</span>
                        </div>
                        <p className="f-12 dropdownPara">
                         {t("Newsfeed.Unfollow User")}
                        </p>
                      </div>
                    {/* </Dropdown.Item> : ''} */}
                    </Dropdown.Item> 
                   )}

                    {isRequestSent &&
                      singlepostList?.postOriginType !== "Company" && (
                        <Dropdown.Item as="button" className="dropdownList">
                                    <div 
                                    onClick={() => {
                              setShowCancelM(true);
                              setUid(singlepostList?.userUid);
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <CancelOutlinedIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt f-14 redText">{t("Recommendations.Cancel Request")}</span>
                          </div>
                          <p className="f-12 dropdownPara">  {t("Recommendations.Cancel Request")}</p>
                        </div>
                        </Dropdown.Item>
                        )
                      }

                    {isRequestReceived &&
                      singlepostList?.postOriginType !== "Company" && (
                        <Dropdown.Item as="button" className="dropdownList">
                          <div
                            onClick={() => {
                              AcceptIncomingRequest(singlepostList?.userUid);
                              toggleDropdown();
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <CheckOutlinedIcon className="material-symbols-sharp me-2" />
                              <span className="dropdownTxt f-14">
                                {t("Connections.Accept")}
                              </span>
                            </div>
                            <p className="f-12 dropdownPara">
                              {t("Connections.Accept")}
                            </p>
                          </div>
                        </Dropdown.Item>
                      )}

                    {(isConnectedCheck ||
                      singlepostList?.isConnectedByYou === true) && (
                      <Dropdown.Item as="button" className="dropdownList">
                        <div
                          onClick={() => {
                            handleShowModal();
                            setUid(singlepostList?.userUid);
                          }}>
                          <div className="d-flex align-items-center">
                            <PersonOffSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt f-14 redText">{t("Connections.Disconnect")}</span>
                          </div>
                          <p className="f-12 dropdownPara">{t("Connections.Disconnect User")}</p>
                        </div>
                      </Dropdown.Item>
                    )}                         
                  </>
                )}


              {singlepostList?.isOwned === false && (
                <Dropdown.Item as="button" className="dropdownList">
                  <div
                    onClick={() => {
                      setReportPost(!reportPost);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <ReportGmailerrorredSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14">{t("Newsfeed.Report Post")}</span>
                    </div>
                    <p className="f-12 dropdownPara"> 
                      {/* We won't let {singlepostList.userName} know who reported */}
                       {/* {t("Newsfeed.We won't let know")} {singlepostList.userName} ,{t("Newsfeed.who reported")}  */}
                        {t("Newsfeed.We won't let Welinkjobs.know who reported")}

                    </p>
                  </div>
                </Dropdown.Item>
              )}


              {singlepostList?.isOwned && (
                <>
                  <>
                    {ispin ? (
                      <Dropdown.Item as="button" className="dropdownList">
                        <div
                          onClick={() => {
                            UnPinPost();
                            toggleDropdown();
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <PushPinOutlinedIcon className="material-symbols-sharp me-2" />

                            {/* <img src={pin} /> */}
                            <span className="dropdownTxt f-14">{t("Newsfeed.Unpin")}</span>
                          </div>
                          <p className="f-12 dropdownPara">{t("Newsfeed.Unpin")}</p>
                        </div>
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item as="button" className="dropdownList">
                        <div
                          onClick={() => {
                            PinPost();
                            toggleDropdown();
                          }}
                        >
                          <div className="d-flex align-items-center">
                            {/* <img src={pin} /> */}
                            <PushPinIcon className="material-symbols-sharp me-2" />

                            <span className="dropdownTxt f-14">{t("Newsfeed.Pin Post")}</span>
                          </div>
                          <p className="f-12 dropdownPara">{t("Newsfeed.Pin Post")}</p>
                        </div>
                      </Dropdown.Item>
                    )}
                  </>
                </>
              )}

           {/* {console.log("singlepostList", singlepostList)} */}
              {singlepostList?.isOwned === false && (     
                 <>
                  {singlepostList?.postActionsInfo?.isHidden === true 
                  // ||  isHidden === true
                                        ? (
                                       <Dropdown.Item as="button" className="dropdownList">
                                         <div
                                           onClick={() => {
                                             UnhidePost();
                                             toggleDropdown();
                                           }}
                                         >
                                           <div className="d-flex align-items-center">
                                             <HideSourceSharpIcon className="material-symbols-sharp me-2" />
                                             <span className="dropdownTxt f-14">{t("Newsfeed.UnHide Post")}</span>
                                           </div>
                                           <p className="f-12 dropdownPara">{t("Newsfeed.UnHide Post")}</p>
                                         </div>
                                       </Dropdown.Item>
                                     ) : (
                                       <Dropdown.Item as="button" className="dropdownList">
                                         <div
                                           onClick={() => {
                                             hidePost();
                                             toggleDropdown();
                                           }}
                                         >
                                           <div className="d-flex align-items-center">
                                             <HideSourceSharpIcon className="material-symbols-sharp me-2" />
                                             <span className="dropdownTxt f-14">{t("Newsfeed.Hide Post")} </span>
                                           </div>
                                           <p className="f-12 dropdownPara">{t("Newsfeed.Hide Post")}</p>
                                         </div>
                                       </Dropdown.Item>
                                     )}
                {/* <Dropdown.Item as="button" className="dropdownList">
                  <Link
                    onClick={() => {
                      hidePost();
                      toggleDropdown();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <HideSourceSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14">{t("Newsfeed.UnHide Post")}</span>
                    </div>
                    <p className="f-12 dropdownPara">{t("Newsfeed.UnHide Post")}</p>
                  </Link>
                </Dropdown.Item> */}
                 </>
              )}

              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    copyPost();
                    toggleDropdown();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ContentCopySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Newsfeed.Copy Link")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Newsfeed.Copy Post Link")}</p>
                </div>
              </Dropdown.Item>
              {singlepostList?.isOwned && (
                <>
                  <Dropdown.Item as="button" className="dropdownList">
                    {/* <Link onClick={PostsDetails}> */}
                    <div
                      onClick={() => {
                        openModal()
                      }} >
                      <div className="d-flex align-items-center">
                        <UpdateSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt f-14">{t("Drafts.Update Post")}</span>
                      </div>
                      <p className="f-12 dropdownPara">{t("Drafts.Update Post")}</p>
                    </div>
                  </Dropdown.Item>

                  <Dropdown.Item as="button" className="dropdownList">
                    <div
                      onClick={() => {
                        setShow(!show);
                        toggleDropdown();
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />

                        <span className="dropdownTxt f-14 redText">{t("Drafts.Delete")}</span>
                      </div>
                      <p className="f-12 dropdownPara">
                       {t("Drafts.Once Deleted it can't be recovered")}
                      </p>
                    </div>
                  </Dropdown.Item>


                </>
              )}


            </Dropdown.Menu>
          )}
        </div>
      </div>

      {console.log("singlepostListDatakkkkkkkkkk", singlepostListData)}

      {/* // Update Modal */}

      {showModal && (
        <Portal layer="modal">
        {singlepostListData?.cntntTypCategory === "SharePost" ? (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            {/* {console.log("singlepostListDatakkkkkkkkkk", singlepostListData)} */}

            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("Newsfeed.Update Shared Post")}</h6>

                  {/* <h6>{singlepostListData.cntntTypCategory === "TextWithVideo" || singlepostListData.cntntTypCategory === "Video" ? "Update Video Post" : "Update Post"}</h6> */}
                  <Select
                    defaultValue={privacy.find(
                      (option) => option.value === privacyType
                    )}
                    onChange={(selectedOption) => {
                      setPrivacyType(selectedOption.value);
                    }}
                    options={privacy}
                    placeholder={t("Newsfeed.Select Privacy")}
                    styles={customStyles}
                    formatOptionLabel={({ label, icon }) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {icon}
                        <span style={{ marginLeft: 8 }}>{label}</span>
                      </div>
                    )}
                  />
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={closeModal}
                  />
                </div>

                <div className="m-3">

                  <div className="d-flex align-items-center mt-4">
                    <div className="ImgAvatar">
                      <img
                        src={singlepostListData?.postInfo?.userAvatar}
                        alt=""
                        style={{ borderRadius: "50px" }}
                      />
                    </div>

                    <div className="ms-2">
                      <h4 className="f-14 fw-bold mb-0">
                        {singlepostListData?.postInfo?.userName}{" "}
                      </h4>
                      <p className="f-12 f-600 fst-italic">{singlepostListData?.postInfo?.title}</p>
                      <p className="f-12">{singlepostListData?.postInfo?.additionalInfo}</p>
                      <p className="f-10 label">
                        {moment
                          .utc(singlepostListData?.postInfo?.creationTime)
                          .local()
                          .format("DD MMMM YYYY [at] h:mm a")}
                      </p>
                    </div>
                  </div>
                  <div>
                    {/* {singlepostListData?.postInfo?.postContent && (
                        <div className="f-14 p-2 postContent">
                          <ReactQuill 
                            value={FormattedContent}
                            ref={editorRef}
                            onChange={handleChange}
                            modules={{ toolbar: false }}
                            placeholder="Update post here"
                          />


                          {showSuggestions && (
                            <ul className="suggestion-box">
                              {mentionType === "Hashtag" ? <li
                                onMouseDown={(e) => {
                                  e.preventDefault(); // Prevent editor blur
                                  insertMention(
                                    SearchText,
                                    null
                                  );
                                }}
                                className="suggestion-item"
                              >
                                <span>{SearchText ? `#${SearchText}` : ''}</span>
                              </li> : null}
                              {suggestions?.map((item, index) => (
                                <li
                                  key={index}
                                  onMouseDown={(e) => {
                                    e.preventDefault(); // Prevent editor blur
                                    insertMention(
                                      mentionType === "UserMention"
                                        ? item?.entityName
                                        : item?.hashTag,
                                      mentionType === "UserMention"
                                        ? item?.userUid
                                        : null,
                                        item.entityType
                                    );
                                  }}
                                  className="suggestion-item"
                                >
                                  {mentionType === "UserMention" ? (
                                    <>
                                      <img
                                        src={item?.avatar}
                                        alt={item?.entityName}
                                        className="avatar"
                                      />
                                      <span>{item?.entityName}</span>
                                    </>
                                  ) : (
                                    <span>#{item?.hashTag}</span>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )} */}
                    {sharedPostContent !== null && (
                      <div className="f-14 p-2 postContent">
                        <ReactQuill
                          value={sharedPostContent}
                          //value={sharedPostFormattedContent}
                          ref={editorRef}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown1}
                          modules={{ toolbar: false }}
                          placeholder={t("Newsfeed.Update Shared Post")}
                        />

                        {showSuggestions && (
                          <ul className="suggestion-box">
                            {mentionType === "Hashtag" ? <li
                              onMouseDown={(e) => {
                                e.preventDefault(); // Prevent editor blur
                                insertMention(
                                  SearchText,
                                  null
                                );
                              }}
                              className="suggestion-item"
                            >
                              <span>{SearchText ? `#${SearchText}` : ''}</span>
                            </li> : null}
                            {suggestions?.map((item, index) => (
                              <li
                                key={index}
                                onMouseDown={(e) => {
                                  e.preventDefault(); // Prevent editor blur
                                  insertMention(
                                    mentionType === "UserMention"
                                      ? item?.entityName
                                      : item?.hashTag,
                                    mentionType === "UserMention"
                                      ? item?.userUid
                                      : null,
                                    item?.entityType
                                  );
                                }}
                                className="suggestion-item"
                              >
                                {mentionType === "UserMention" ? (
                                  <>
                                    <img
                                      src={item?.avatar}
                                      alt={item?.entityName}
                                      className="avatar"
                                    />
                                    <span>{item?.entityName}</span>
                                  </>
                                ) : (
                                  <span>#{item?.hashTag}</span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}

                    {singlepostListData?.postInfo ? (
                      <>
                        <div className="row w-94 m-0 singlePostLink">
                          <div className="featured-card user-postOnlyContent">
                            <div className="feature-content p-2 d-flex justify-content-between">
                              {singlepostListData?.postInfo?.postOriginType ===
                                "Company" ? (
                                <Link
                                  to={`/Company/${singlepostListData?.postInfo?.userUid}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="ImgAvatar">
                                      <img
                                        src={
                                          singlepostListData?.postInfo?.userAvatar
                                        }
                                        alt=""
                                        style={{ borderRadius: "50px" }}
                                      />
                                    </div>
                                    <div className="ms-2">
                                      <h4 className="f-14 fw-bold mb-0">
                                        {singlepostListData?.postInfo?.userName}
                                      </h4>
                                      <p className="f-12">

                                        {moment
                                          .utc(
                                            singlepostListData?.postInfo
                                              ?.creationTime
                                          )
                                          .local()
                                          .format(
                                            "DD MMMM YYYY [at] h:mm a"
                                          )}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              ) : (
                                <Link
                                  to={`/User/${singlepostListData?.postInfo?.userUid}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="ImgAvatar">
                                      <img
                                        src={
                                          singlepostListData?.postInfo?.userAvatar
                                        }
                                        alt=""
                                        style={{ borderRadius: "50px" }}
                                      />
                                    </div>
                                    <div className="ms-2">
                                      <h4 className="f-14 fw-bold mb-0">
                                        {singlepostListData?.postInfo?.userName}
                                      </h4>
                                      <p className="f-12">
                                        {moment
                                          .utc(
                                            singlepostListData?.postInfo
                                              ?.creationTime
                                          )
                                          .local()
                                          .format(
                                            "DD MMMM YYYY [at] h:mm a"
                                          )}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              )}


                            </div>

                            {singlepostListData?.postInfo?.sharedPost && (
                              <>
                                <div className="f-14 p-2 postContent">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        sharedPostFormattedContent1,
                                    }}
                                  />
                                </div>

                                <div
                                  className="feed-post"
                                  style={{
                                    paddingTop:
                                      singlepostListData?.postInfo?.sharedPost?.postMediaCount === 0
                                        ? "60px"
                                        : "4px",
                                  }}
                                >
                                  <div className="row">
                                    {singlepostListData?.postInfo?.sharedPost?.mediaFilesList
                                      ?.slice(0, 4)
                                      ?.map((file, idx) => (
                                        <div
                                          key={idx}
                                          className={`col-${singlepostListData?.postInfo?.sharedPost
                                            ?.mediaFilesList
                                            .length === 1
                                            ? "12"
                                            : "6"
                                            } ${singlepostListData?.postInfo
                                              ?.sharedPost?.mediaFilesList
                                              .length === 3 && idx === 0
                                              ? "col-12"
                                              : ""
                                            }`}
                                          style={{
                                            position: "relative",
                                            padding:
                                              singlepostListData?.postInfo
                                                ?.sharedPost?.mediaFilesList
                                                .length === 1
                                                ? "0"
                                                : singlepostListData?.postInfo
                                                  ?.sharedPost?.mediaFilesList
                                                  .length === 3 &&
                                                  idx === 0
                                                  ? "0 0 5px 0"
                                                  : singlepostListData?.postInfo
                                                    ?.sharedPost?.mediaFilesList
                                                    .length === 3 &&
                                                    idx === 1
                                                    ? "0 5px 5px 0"
                                                    : singlepostListData?.postInfo
                                                      ?.sharedPost?.mediaFilesList
                                                      .length === 4 &&
                                                      idx === 2
                                                      ? "0 5px 0 0"
                                                      : singlepostListData?.postInfo
                                                        ?.sharedPost?.mediaFilesList
                                                        .length === 4 &&
                                                        idx === 0
                                                        ? "0 5px 5px 0"
                                                        : singlepostListData?.postInfo
                                                          ?.sharedPost?.mediaFilesList
                                                          .length === 2 &&
                                                          idx === 0
                                                          ? "0 5px 5px 0"
                                                          : "0",
                                          }}
                                        >
                                          <h2>{file.length}</h2>

                                          {/* <img
                                              src={file.mediaName}
                                              alt=""
                                              className="img-fluid"
                                              width={"100%"}
                                            /> */}
                                          {file.mediaType === "Image" ? (
                                            <ImageWithLoader
                                              src={`${file.mediaName}`}
                                              alt=""
                                              className="img-fluid"
                                              width="100%"
                                              style={{ maxHeight: "300px" }}
                                            />
                                          ) : (
                                            // <video
                                            //   controls
                                            //   src={file.mediaName}
                                            //   className="img-fluid"
                                            //   width="100%"
                                            // />
                                            // <iframe
                                            //   style={{
                                            //     marginTop: '-1px',
                                            //   }}
                                            //   width="100%"
                                            //   height="300"
                                            //   src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${postDataItem.restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                                            //   frameBorder="0"
                                            //   allow="autoplay"
                                            //   allowFullScreen
                                            // />
                                            <video
                                              ref={sharedVideoRef}
                                              controls
                                              autoPlay={false}
                                              muted
                                              width="100%"
                                              height="300"
                                              playsInline
                                              className="video-js"
                                              style={{ backgroundColor: "#000", maxHeight: "300px" }}
                                            />
                                          )}

                                          {idx === 3 &&
                                            singlepostListData?.postInfo?.sharedPost
                                              ?.postMediaCount > 4 && (
                                              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                +
                                                {singlepostListData?.postInfo?.sharedPost
                                                  ?.postMediaCount - 4}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div
                    className="feed-post"
                    style={{
                      paddingTop:
                        singlepostListData?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                    }}
                  >
                    <div className="row">
                      {singlepostListData?.postInfo?.mediaFilesList
                        ?.slice(0, 4)
                        .map((file, idx) => (
                          <div
                            key={idx}
                            className={`col-${singlepostListData?.postInfo?.mediaFilesList.length === 1
                              ? "12"
                              : "6"
                              } ${singlepostListData?.postInfo?.mediaFilesList.length === 3 &&
                                idx === 0
                                ? "col-12"
                                : ""
                              }`}
                            style={{
                              position: "relative",
                              padding:
                                singlepostListData?.postInfo?.mediaFilesList.length === 3 &&
                                  idx === 0
                                  ? "0 0 5px 0"
                                  : singlepostListData?.postInfo?.mediaFilesList.length === 3 &&
                                    idx === 1
                                    ? "0 5px 5px 0"
                                    : singlepostListData?.postInfo?.mediaFilesList.length === 4 &&
                                      idx === 2
                                      ? "0 5px 0 0"
                                      : singlepostListData?.postInfo?.mediaFilesList.length === 4 &&
                                        idx === 0
                                        ? "0 5px 5px 0"
                                        : singlepostListData?.postInfo?.mediaFilesList.length === 2 &&
                                          idx === 0
                                          ? "0 5px 5px 0"
                                          : "",
                            }}
                          >
                            <ImageWithLoader
                              src={file.mediaName}
                              alt=""
                              className="img-fluid"
                              width={"100%"}
                            />
                            {idx === 3 && singlepostListData?.postInfo?.postMediaCount > 4 && (
                              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                +{singlepostListData?.postInfo?.postMediaCount - 4}
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                <div className="m-3 mb-1 d-flex align-items-center">
                  <button
                    className="mainBtn ms-auto"
                    disabled={isloading}
                    onClick={updateSharedPost}
                  >
                    {isloading === true ? `${t("User Profile.Updating")}` : `${t("Drafts.Update Post")}`}
                  </button>
                </div>



              </div>
            </div>
          </div>


        ) :

          singlepostListData?.cntntTypCategory === "Article" ? (
            <ArticleUpdate
              showModal={showModal}
              closeModal={closeModal}
              article={article}
              setArticle={setArticle}
              articleTagName={article?.infoarticleTags_Name}
              articleSlug={article?.info?.postInfo?.articleInfo?.titleSlug}
              articleId={article?.info?.postInfo?.articleInfo?.articleId}
              postId={article?.info?.postInfo?.postId}
              ImageUrl={article?.info?.postInfo?.mediaFilesList?.[0]?.mediaName}
            // postList={postList}
            // restrictedViewerToken={restrictedViewerToken}
            // setPostList={setPostList}

            // onUpdateSuccess={onUpdateSuccess}
            />
          ) :
            (
              <div className="m-3">
                <div
                  className="modal fade show postAdd"
                  tabIndex="-1"
                  role="dialog"
                  style={{ display: "block" }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content p-2">
                      <div className="modalBorder d-flex justify-content-between align-items-center">
                        <h6>{singlepostListData.cntntTypCategory === "TextWithVideo" || singlepostListData.cntntTypCategory === "Video" ? `${t("Drafts.Update Video Post")}` : `${t("Drafts.Update Post")}`}</h6>

                        <CloseSharpIcon
                          className="material-symbols-sharp me-2 pointer"
                          onClick={closeModal}
                        />
                      </div>

                      <div className="m-3">
                        <ReactQuill
                          ref={editorRef}
                          value={postContent}
                          // onChange={setPostContent}
                          onChange={handleChange}
                          // onKeyDown={handlePaste}
                          onKeyDown={handleKeyDown1}
                          placeholder="Update Post Here"

                          modules={{
                            toolbar: false,
                          }}
                          formats={[
                            "header",
                            "font",
                            "size",
                            "bold",
                            "italic",
                            "underline",
                            "strike",
                            "blockquote",
                            "list",
                            "bullet",
                            "indent",
                            "link",
                          ]}
                        />
                        {showSuggestions && (
                          <ul className="suggestion-box">
                            {mentionType === "Hashtag" ? <li
                              onMouseDown={(e) => {
                                e.preventDefault(); // Prevent editor blur
                                insertMention(
                                  SearchText,
                                  null
                                );
                              }}
                              className="suggestion-item"
                            >
                              <span>{SearchText ? `#${SearchText}` : ''}</span>
                            </li> : null}
                            {suggestions?.map((item, index) => (
                              <li
                                key={index}
                                onMouseDown={(e) => {
                                  e.preventDefault(); // Prevent editor blur
                                  e.stopPropagation();
                                  insertMention(
                                    mentionType === "UserMention"
                                      ? item?.entityName
                                      : item?.hashTag,
                                    mentionType === "UserMention"
                                      ? item?.userUid
                                      : null,
                                    item.entityType
                                  );
                                }}
                                className="suggestion-item"
                              >
                                {mentionType === "UserMention" ? (
                                  <>
                                    <img
                                      src={item?.avatar}
                                      alt={item?.entityName}
                                      className="avatar"
                                    />
                                    <span>{item?.entityName}</span>
                                  </>
                                ) : (
                                  <span>#{item?.hashTag}</span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}

                        {/* Main post image */}
                        <div
                          className="feed-post"
                          style={{
                            paddingTop: singlepostListData?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                          }}
                        >

                        </div>
                      </div>

                      {/* Adding Extra Image */}
                      <div className="modal-border d-flex justify-content-center align-items-center">
                        <input
                          id="fileInput"
                          type="file"
                          onChange={(event) => {
                            imageSelect(event);
                          }}
                          style={{ display: "none" }}
                          ref={inputFileRef}
                          multiple
                        />

                        {images.length > 0 && (
                          <div className="post-selected d-flex justify-content-center flex-wrap">
                            {images.map((image, index) => (
                              <div key={index} className="position-relative m-2">
                                <img
                                  src={image.url}
                                  alt={`Selected Image ${index}`}
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "300px",
                                    objectFit: "cover",
                                  }}
                                />
                                <button
                                  onClick={() => removeImage(index)}
                                  className="btn btn-danger position-absolute top-0 end-0"
                                  style={{
                                    transform: "translate(50%, -50%)",
                                    borderRadius: "50%",
                                    width: "24px",
                                    height: "24px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "0",
                                  }}
                                >
                                  &times;
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {userSelectedImage?.length > 0 && (
                        <div className="post-selected hhh d-flex justify-content-center flex-wrap">
                          {userSelectedImage?.map((media, index) => (
                            <div key={index} className="position-relative m-2 col-12 text-center"  >
                              {media.mediaType === "Image" ? (
                                <>
                                  <div key={index} className="position-relative m-2">
                                    <ImageWithLoader
                                      src={media.mediaName}
                                      alt={`Selected Image ${index}`}
                                      style={{
                                        maxWidth: "200px",
                                        maxHeight: "300px",
                                        objectFit: "cover",
                                      }}
                                    />
                                    <button
                                      onClick={() => userImages(index)}
                                      className="btn btn-danger position-absolute top-0 end-0"
                                      style={{
                                        transform: "translate(-500%, -50%)",
                                        borderRadius: "50%",
                                        width: "24px",
                                        height: "24px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "0",
                                      }}
                                    >
                                      &times;
                                    </button>
                                  </div>
                                </>

                              ) : (
                                // <video
                                //   src={media.mediaName}
                                //   controls
                                //   style={{
                                //     maxWidth: "200px",
                                //     maxHeight: "300px",
                                //     objectFit: "cover",
                                //   }}
                                ///>
                                <div style={{ width: '100%', maxWidth: '700px' }}>
                                  {/* <iframe
                              style={{
                                width: '100%',
                                height: '300px',
                                marginTop: '-2px',
                              }}
                              src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${media?.mediaInfo}/?accessToken=${singlepostListDataItem.restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                              frameBorder="0"
                              allow="autoplay"
                              allowFullScreen
                            /> */}
                                  <video
                                    ref={mainVideoRef}
                                    controls
                                    autoPlay={false}
                                    muted
                                    width="100%"
                                    height="300"
                                    playsInline
                                    className="video-js"
                                    style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }}
                                  // style={{ backgroundColor: "#000", maxHeight: "300px" }}
                                  />
                                </div>
                              )}
                              {/* <button
                          onClick={() => userImages(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        > 
                          &times;
                        </button>*/}
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="m-3 mb-1 d-flex align-items-center">
                        <form className="form" action="#" method="post" id="form">
                          <input
                            type="file"
                            name="Image"
                            id="image"
                            multiple
                            className="d-none"
                            onChange={(event) => {
                              imageSelect(event);
                            }}
                            ref={inputFileRef}
                          />
                          <AddAPhotoSharpIcon
                            className="material-symbols-sharp me-2 mt-2 pointer"
                            onClick={() => inputFileRef.current.click()} // Trigger the file input click
                          />
                        </form>
                        <button
                          className="mainBtn ms-auto"
                          disabled={isloading}
                          onClick={handleSubmit}
                        >
                          {isloading === true ? `${t("User Profile.Updating")}` : `${t("Drafts.Update Post")}`}
                        </button>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

            )

        }
        </Portal>
      )}

      {showPost && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex  align-items-center p-2">
                <h6>{t("NewsFeed.Post Something")}</h6>
                {/* <div className="post-dropdown-cont"> */}
                <Select
                  defaultValue={privacyType}
                  onChange={(e) => {
                    setPrivacyType(e.value);
                  }}
                  options={privacy}
                  placeholder={"Select Privacy"}
                  styles={customStyles}
                />
                {/* </div> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    // if (postContent === "") {
                    //   setShowSecondModal(false);
                    // } else {
                    handleClosePost(false);
                    // }
                  }}
                />
              </div>
              <div className="d-flex align-items-center m-3 pb-3 modalBorder ">
                <div className="ImgAvatar">
                  <img src={NewsFeed.companyLogo} alt="" />
                </div>
                <p className="f-16  AddPost ms-2">
                  {/* What's on your mind? */}
                  {t("NewsFeed.What's on your mind?")}
                  </p>
              </div>
              <div className="m-3">
                <textarea
                  autoFocus={true}
                  id="about"
                  placeholder={t("Newsfeed.What do you want to talk about?")}
                  // placeholder="What do you want to talk about?"
                  name="about"
                  value={postContent}
                  onChange={(e) => setPostContent(e.target.value)}
                  invalid={display && postContent === ""}
                  rows="4"
                  cols="65"
                  style={{ width: "100%" }}
                ></textarea>
              </div>

              <div className="modal-border d-flex justify-content-center align-items-center">
                <input
                  id="fileInput"
                  type="file"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                  ref={inputFileRef}
                  multiple // Allow multiple file selection
                />

                {selectedImages.length > 0 && (
                  <div className="post-selected-images d-flex justify-content-center flex-wrap">
                    {selectedImages.map((imageUrl, index) => (
                      <div key={index} className="position-relative m-2">
                        <img
                          src={imageUrl}
                          alt={`Selected Image ${index + 1}`}
                          style={{
                            maxWidth: "200px",
                            maxHeight: "300px",
                            objectFit: "cover",
                          }}
                        />
                        <button
                          onClick={() => handleRemoveImage(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="m-3 d-flex align-items-center">

                <form className="form" action="#" method="post" id="form">
                  <input
                    type="file"
                    name="Image"
                    id="image"
                    multiple
                    className="d-none"
                    onChange={imageSelect}
                  />
                  <ImageSharpIcon
                    className="material-symbols-sharp me-2 mt-2 pointer"
                  />
                </form>

                <button
                  className="mainBtn ms-auto"
                  onClick={() => {
                    setShowPost(false);
                    UpdatePostAsDraft();
                  }}
                >
                 {t("Drafts.Update Post")}
                </button>
                {/* <div className="post-button m-2">
                
                {/* </div> */}
              </div>

              <div
                className="card-body d-flex flex-wrap justify-content-start"
                id="container"
              >
                {renderImages()}
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {show && (
        <Portal layer="modal">
        <div
          className="modal fade show "
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deletePost()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {reportPost && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are you sure you want to Report this post?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handlereportPost();
                  }}
                />
              </div>

              <div className="lableStyle HuzlableStyle mt-2">
                <input
                  type="text"
                  placeholder={t("modals.Enter feedback here")}
                  required
                  value={remark}
                  style={{ width: "100%" }}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>

              <div className="col-md-12 text-end mt-4">
                <button type="button" className="mainBtn1" onClick={ReportPost}>
                  {t("Newsfeed.Report")}
                </button>
              </div>

            </div>
          </div>
        </div>
        </Portal>
      )}

      {showUnfollowModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                {/* <h6>Unfollow User</h6> */}
                <h6>{t("modals.Are you sure you want to unfollow")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseUnfollowModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="closebtn"
                      onClick={() => { singlepostList?.postOriginType === 'Company' 
                    ? UnFollowCompany() : unFollowUser() }}
                  // onClick={() => unFollowUser() }
                >
                 {t("Recommendations.Unfollow")}  
                </button>
              </div>

            </div>
          </div>
        </div>
        </Portal>
      )}

{showCancelM && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

{showModalDisC && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {t("modals.Are you sure you want to Disconnect")}
                </h6>
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn "
                  onClick={() => DisconnectUser()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default SinglePostInteraction;
